import { Card, Form } from 'ui';
import { VideoListContent } from './video-list-content';
import { VideoListFilters, type VideoListFiltersFormValues } from './video-list-filters';
import { useVideoSortFilterOptions } from './video-list-filters/hooks';

type P = {
  getPathToVideoDetail: (id: string) => string;
};

const VideoList = ({ getPathToVideoDetail }: P) => {
  const sortOptions = useVideoSortFilterOptions();

  const initialValues: VideoListFiltersFormValues = {
    sort: sortOptions.find((option) => option.value === 'latest_created'),
    type: 'published',
  };

  return (
    <Card>
      <Form<VideoListFiltersFormValues> initialValues={initialValues} noOptional>
        <VideoListFilters<VideoListFiltersFormValues> />

        <Form.Item<VideoListFiltersFormValues> dependencies={['search', 'type', 'sort']} noStyle>
          {({ getFieldsValue }) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            const { search, sort, type } = getFieldsValue(true) as VideoListFiltersFormValues;

            return (
              <VideoListContent
                filter={{
                  search,
                  type,
                }}
                getPathToVideoDetail={getPathToVideoDetail}
                sort={sort?.meta}
              />
            );
          }}
        </Form.Item>
      </Form>
    </Card>
  );
};

export default VideoList;
